import { Injectable } from '@angular/core';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { forkJoin, of } from 'rxjs';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import {
  ActionActionTypes,
  ActionOnServerUpdated,
  ActionsActionToggleLoading,
  ActionsPageCancelled,
  ActionsPageLoaded,
  ActionsPageRequested,
  ActionsPageToggleLoading,
  ActionUpdated,
  FireActionSuccess,
  ThrowActionError,
} from '../_actions/action.actions';
import { Router } from '@angular/router';
import { AuthService } from '../../auth';
import { ActionService } from '../_services/action.service';

@Injectable()
export class ActionEffects {
  showPageLoadingDistpatcher = new ActionsPageToggleLoading({ isLoading: true });
  hidePageLoadingDistpatcher = new ActionsPageToggleLoading({ isLoading: false });
  showActionLoadingDistpatcher = new ActionsActionToggleLoading({ isLoading: true });
  hideActionLoadingDistpatcher = new ActionsActionToggleLoading({ isLoading: false });

  @Effect()
  loadActionsPage$ = this.actions$.pipe(
    ofType<ActionsPageRequested>(ActionActionTypes.ActionsPageRequested),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showPageLoadingDistpatcher);
      const requestToServer = this.action.findActions(payload.page);
      const lastQuery = of(payload.page);
      return forkJoin([requestToServer, lastQuery]).pipe(
        catchError((error) => {
          return of([error]);
        }),
        map((response) => {
          if (response[0] && response[0].error) {
            if (response[0].status === 401) {
              return response[0];
            } else if (response[0].status === 403) {
              this.router.navigateByUrl('/error/403');
              return new ActionsPageCancelled();
            } else {
              this.store.dispatch(new ThrowActionError({ error: response[0].error.error }));
              return new ActionsPageCancelled();
            }
          } else {
            const result = response[0];
            return new ActionsPageLoaded({
              actions: result.data,
              totalCount: result.count,
              page: response[1],
            });
          }
        }),
      );
    }),
  );

  @Effect()
  updateAction$ = this.actions$.pipe(
    ofType<ActionOnServerUpdated>(ActionActionTypes.ActionOnServerUpdated),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showActionLoadingDistpatcher);
      return this.action.updateAction(payload.action).pipe(
        catchError((error) => {
          return of({ error });
        }),
        map((res) => {
          if (res && res.error) {
            return new ThrowActionError({ error: res.error });
          } else {
            this.store.dispatch(this.hideActionLoadingDistpatcher);
            this.store.dispatch(
              new FireActionSuccess({ action_type: ActionActionTypes.ActionUpdated }),
            );
            return new ActionUpdated(payload);
          }
        }),
      );
    }),
  );

  constructor(
    private actions$: Actions,
    private action: ActionService,
    private store: Store<AppState>,
    private router: Router,
    private authService: AuthService,
  ) {}
}
